import React from 'react';
import useTracks from '../../hooks/useTracks';
import useTrackEnabled from '../../hooks/useTrackEnabled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import { getParticipantName, isAudioAppointment } from '../../common/utility';
import useUnkownGuests from '../../hooks/useUnknownGuests';

import styles from './ParticipantInfo.module.scss';

const UNKNOWNGUESTS = 'Unknown Guest';

function ParticipantInfo({ participant, appointment }) {
    const { guests } = useUnkownGuests();
    const { tracks } = useTracks(participant, false, isAudioAppointment(appointment));
    const isAudioTrackEnabled = useTrackEnabled(tracks, 'audio');

    function isEnabled() {
        return isAudioTrackEnabled;
    }

    function getParticipantIdentity(identity) {
        const participantName = getParticipantName(identity, appointment);

        if (participantName != UNKNOWNGUESTS) {
            return participantName;
        }

        return guests[identity] || UNKNOWNGUESTS;
    }

    return (
        <div className={styles.participant}>
            {getParticipantIdentity(participant.identity)}
            <FontAwesomeIcon
                className={`${styles.icon} ${isEnabled() ? styles.enabled : styles.disabled}`}
                icon={faMicrophone}
            />
        </div>
    );
}

export default ParticipantInfo;
